// The event goal (Lane 1354, negotiation PLAN section 4): one line the buyer
// writes, internal only. The quick picks fill the line; the buyer can edit it.
export const GOAL_MAX = 600;

// The goal in the buyer's own words (Lane 1368, plan B3.8): several lines, at most
// this many characters, and no picks. Only while sourcingChatIntakeEnabled is on.
export const GOAL_MAX_OWN_WORDS = 2000;
// What may be typed before cleaning (the server's GOAL_RAW_MAX). The 2,000 limit is
// checked on the cleaned text, in characters, as the server does (Codex S1 r1 #2).
export const GOAL_RAW_MAX = 20000;

export const GOAL_PICKS = [
  "Keep today's suppliers, better price",
  'Best total cost, open to moving',
  'Move some or all business',
  'Add a second source',
];

// The same characters as the server's clean_goal (helpers/sourcing_actions.py),
// written out one by one: JavaScript's trim and Python's split do not agree on
// every character. Pinned by goalVectors.json, which both sides run.
const BREAKS = /\r\n|[\r\u2028\u2029\u0085]/g;
const SPACE = '[ \\t\\u000b\\u000c\\u00a0\\u1680\\u2000-\\u200a\\u202f\\u205f\\u3000\\ufeff]';
const TRIM = new RegExp(`^${SPACE}+|${SPACE}+$`, 'g');

export function goalMax(multiline = false) {
  return multiline ? GOAL_MAX_OWN_WORDS : GOAL_MAX;
}

// The goal's length as the server counts it (characters, not UTF-16 units).
export function goalLength(text) {
  return Array.from(String(text || '')).length;
}

// The goal as the server saves it. One line (the default): spaces collapsed.
// Several lines (the switch on): line breaks kept, each line trimmed, two or more
// empty lines in a row become one, empty lines at the ends go.
export function cleanGoal(text, multiline = false) {
  if (!multiline) return String(text || '').split(/\s+/).filter(Boolean).join(' ');
  const lines = String(text || '').replace(BREAKS, '\n').split('\n').map((l) => l.replace(TRIM, ''));
  return lines.join('\n').replace(/\n{3,}/g, '\n\n').replace(/^\n+|\n+$/g, '');
}
